import { __assign } from "tslib";
import React from 'react';
import Icon from '../../icon';
import styles from './styles.css.js';
import clsx from 'clsx';
import { breadcrumbItemClickHandler } from '../item-click-handler';
import useFocusVisible from '../../internal/hooks/focus-visible';
export function BreadcrumbItem(_a) {
    var item = _a.item, onClick = _a.onClick, onFollow = _a.onFollow, _b = _a.isLast, isLast = _b === void 0 ? false : _b, _c = _a.isCompressed, isCompressed = _c === void 0 ? false : _c;
    var focusVisible = useFocusVisible();
    var preventDefault = function (event) { return event.preventDefault(); };
    var onClickHandler = function (event) {
        breadcrumbItemClickHandler(item, onFollow, onClick, event);
    };
    return (React.createElement("div", { className: clsx(styles.breadcrumb, isLast && styles.last) },
        React.createElement("a", __assign({}, focusVisible, { href: item.href || '#', className: isCompressed ? styles.compressed : undefined, "aria-current": isLast ? 'page' : undefined, "aria-disabled": isLast && 'true', onClick: isLast ? preventDefault : onClickHandler }),
            React.createElement("span", null, item.text)),
        !isLast ? React.createElement(Icon, { name: "angle-right", variant: "disabled", className: styles.icon }) : null));
}
//# sourceMappingURL=item.js.map